import a from "axios";

const axios = a.create({
  baseURL: process.env.REACT_APP_BACKEND_API_URL,
});

export default axios
